/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
//import constantName from './key'

/**
 *
 * @param {string} metaData
 * @returns
 */

export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

// permission details
export async function loadDataCopyDetails(searchvalue) {
  // let unassigned
  if (searchvalue) {
    return await api

      .post(`/get_data_copy_scheduling_new`, searchvalue)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get_data_copy_scheduling_new`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }

  // return unassigned
}



//Data scheduling client details section
export function loadDataSchedulingDetails(id) {
  return api
    .post(`/get_data_copy_main_data`, id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function addDataSchedulingDetails(dataScheduling) {

  try {
    const response = await api.post(`/add_data_copy_scheduling_new`, dataScheduling)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateDataSchedulingDetails(dataScheduling) {

  try {
    const response = await api.post(
      `/update_data_copy_scheduling_new`,
      dataScheduling
    )
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
export async function removeDataSchedulingDetails(dataScheduling) {

  try {
    const response = await api.post(
      `/update_recent_teamschedule_service`,
      dataScheduling
    )
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export function loadDataSchedulingServiceDetails(record) {
  return api
    .post(`/get_event_team_schedule_detils_from_lead`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadAgentVacancyDetails(record) {
  return api
    .post(`/get_employee_monthly_schedule_list`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function loadAgentOfficeVacancyDetails(record) {
  return api
    .post(`/get_employee_month_wise_schedule_list`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadShooterHistoryDetails(empId) {
  const payload = {
    empId: empId,
  }
  return api
    .post(`/get_employe_shooter_history`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function dataCommitDetails(finalCommit) {

  try {
    const response = await api.post(`/team_schedule_history`, finalCommit)

    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

//Nas Link
export function loadNasLinkDetails(id) {
  return api
    .post(`/get_all_naslink_data`, id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function addNasLinkDetails(nasLinkDetails) {

  try {
    const response = await api.post(`/add_naslink_data`, nasLinkDetails)

    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateNasLinkDetails(nasLinkDetails) {

  try {
    const response = await api.post(
      `/update_by_naslink_data_id`,
      nasLinkDetails
    )

    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function removeNasLinkDetails(nasLinkDetails) {

  try {
    const response = await api.post(
      `/delete_by_naslink_data_id`,
      nasLinkDetails
    )

    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

//Data Link section
export function loadDataLinkDetails(id) {
  const config = {
    headers: {
      'Cache-Control': 'no-cache', // Prevent caching
    },
  }
  return api
    .post(`/get_all_uploadlink_data`, id, config)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function addDataLinkDetails(dataLinkDetails) {

  try {
    const response = await api.post(`/add_uploadlink_data`, dataLinkDetails)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateDataLinkDetails(dataLinkDetails) {

  try {
    const response = await api.post(
      `/update_by_uploadlink_data_id`,
      dataLinkDetails
    )

    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function removeDataLinkDetails(dataLinkDetails) {

  try {
    const response = await api.post(
      `/delete_by_uploadlink_data_id`,
      dataLinkDetails
    )

    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
export function loadServiceLevelDetails() {
  return api
    .post(`/get_all_service_level_status`, { status: "both" })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export async function uploadQcDetails(qcDetails) {

  try {
    const response = await api.post(`/add_qc_uploadLink`, qcDetails)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
export async function updateNasCommitDetails(qcDetails) {

  try {
    const response = await api.post(`/update_naslink_commit`, qcDetails)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

//loadPendingStatusDetails
export function loadPendingStatusDetails(pendingDetails) {
  return api
    .post(`/get_employee_monthly_schedule_list`, pendingDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function updateCopyDetails(payload) {
  return api
    .post(`/update_data_copied`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}  
//new api url :http://localhost:3000/api/v1/update_data_copy_service_new
export function updateExpandDetails(payload) {
  return api
    .post(`/update_multi_data_copy_service_new`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
//loadDataDetails
export function loadDataDetails(payload) {
  return api  
    .post(`/get_employee_monthly_schedule_list`,payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//loadPendingStatusDetails
export function loadExpandDataDetails(pendingDetails) {
  return api
    .post(`/get_data_copy_services_new`, pendingDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
const remotes = {
  loadRecordsMetaData,
  loadDataCopyDetails,
  loadDataSchedulingServiceDetails,
  loadDataSchedulingDetails,
  addDataSchedulingDetails,
  updateDataSchedulingDetails,
  removeDataSchedulingDetails,
  loadShooterHistoryDetails,
  dataCommitDetails,
  loadAgentVacancyDetails,

  //Nas Link
  loadNasLinkDetails,
  addNasLinkDetails,
  updateNasLinkDetails,
  removeNasLinkDetails,

  //Nas Link
  loadDataLinkDetails,
  addDataLinkDetails,
  updateDataLinkDetails,
  removeDataLinkDetails,
  loadServiceLevelDetails,
  uploadQcDetails,
  updateNasCommitDetails,
  loadPendingStatusDetails,
  updateCopyDetails,
  updateExpandDetails,
  loadDataDetails,
  loadExpandDataDetails,
}

export default remotes
